<template>
  <div class="dashboard-page-wrapper test-page">
    <div class="top-wrap">
      <div class="text-img">
        <h2> Differential Liberation </h2>
        <div v-if="receivedData">
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
            <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else-if="receivedData.testID !== ''" @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
            <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      <div class="top-content" v-if="receivedData">
        <v-img
          src="../../../assets/Images/Assets/top image.png"
          alt="test image"
          width="49px"
          height="49px"
        ></v-img>
        <div class="fields-info">
          <div
            class="fields-info-wrap"
            :style="{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '16px'
            }"
          >
            <div
              v-for="(item, index) in receivedData.headers.filter(
                h => !(h.key && h.key.endsWith('_UOM'))
              )"
              :key="index"
              class="field-item"
            >
              <p style="margin: 0; font-weight: 500;">{{ item.displayName }}</p>
              <p class="test-top-values" style="margin: 0;">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" v-if="typeof item.value === 'number'" class="value-text">
                      {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                    </span>
                    <span v-bind="props" v-else class="value-text">
                      {{ item.value }}
                    </span>
                  </template>
                  <span>{{ item.value }}</span>
                </v-tooltip>
                <span
                  v-if="item.key && receivedData.headers.some(
                    h => h.key === item.key + '_UOM'
                  )"
                  class="uom"
                >
                  &nbsp;{{
                    receivedData.headers.find(
                      h => h.key === item.key + '_UOM'
                    ).value
                  }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>
    <div ref="scrollable" class="tabs-data" tabindex="0" @keydown="handleKeyDown">
      <div class="tabs-toggle">
        <v-tabs v-model="tab">
          <v-tab value="one">Oil Properties</v-tab>
          <v-tab value="two">Gas Properties</v-tab>
          <v-tab value="three">Liberated Gas Compositions</v-tab>
          <v-tab value="four">Residual Oil Compositions</v-tab>
        </v-tabs>
       
        <v-btn-toggle v-if="tab === 'four'" v-model="toggleFractionParent" mandatory class="elevation-0 axis-toggle" @update:modelValue="handleToggleChange">
          <v-btn :value="true" class="switch-btn text-none text-caption">wt%</v-btn>
          <v-btn :value="false" class="switch-btn text-none text-caption">mol%</v-btn>
        </v-btn-toggle>
      </div>

      <v-card-text class="pa-0 pt-3">
        <v-window v-model="tab">
          <v-window-item value="one">
            <OilData @data-updated="handleDataUpdate" />
          </v-window-item>

          <v-window-item value="two">
            <GasData />
          </v-window-item>

          <v-window-item value="three">
            <GasCompData />
          </v-window-item>

          <v-window-item value="four">
            <OilCompData @data-updated="handleDataUpdate" @toggle-fraction="updateToggleFractionComp" ref="oilCompData" />
          </v-window-item>
        </v-window>
      </v-card-text>
    </div>
    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
    <!-- <Filters @drawerStateChanged="handleRightDrawerStateChange" /> -->
  </div>
</template>

<script>
import GasCompData from './GasCompData.vue';
import GasData from './Tables/GasData.vue';
import OilCompData from './Tables/OilCompData.vue';
import OilData from './Tables/OilData.vue';
import TestLoaders from '../Loaders/TestLoaders.vue';
import axios from "axios";
import { blobFromSampleReportResponse } from "../../../utils/sampleReportDownload";
export default {
  components: { OilData, GasData, GasCompData, OilCompData, TestLoaders, },
  name: "DataTabs",
  data: () => ({
    toggleFractionParent: true,
    tab: null,
    receivedData: null,
    assetName: "",
    fieldName: "",
    wellName: "",
    pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
    pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
    pdfLoader: false,
    snackbarMessage: null,
  }),
  methods: {
    updateToggleFractionComp(value) {
      this.toggleFractionParent = value; // Update the parent state when child emits an event
    },
    handleToggleChange() {
        this.$refs.oilCompData.toggleFraction = this.toggleFractionParent; // Sync state with the child
        this.$refs.oilCompData.toggleFractionFunction(); // Call the child's 
    },
    handleDataUpdate(data) {
      this.receivedData = data;
    },
    goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      const tenantId = getTenantPrefix() || "";
      const sampleId = this.$route.params.sampleId;
      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": tenantId,
          },
          responseType: 'blob',
        })
        .then(async (response) => {
          const result = await blobFromSampleReportResponse(response, 'pdf');
          this.pdfLoader = false;
          if (!result.ok) {
            this.snackbarMessage = result.message;
            return;
          }
          const url = URL.createObjectURL(result.blob);
          window.open(url, '_blank');
        })
        .catch(async (error) => {
          this.pdfLoader = false;
          const fallbackDownloadError = "Failed to download PDF report.";
          const data = error.response?.data;
          if (data instanceof Blob) {
            try {
              const text = await data.text();
              const j = JSON.parse(text);
              if (j && Number(j.statusCode) >= 500) {
                this.snackbarMessage = fallbackDownloadError;
                return;
              }
              if (j && j.message) {
                this.snackbarMessage = j.message;
                return;
              }
            } catch (_) {
              /* fall through */
            }
          }
          if (error.response) {
            if (Number(error.response.status) >= 500) {
              this.snackbarMessage = fallbackDownloadError;
              return;
            }
            this.snackbarMessage = "The PDF report is not available for synthetic data in this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.";
          }
        })
        .finally(() => {
          this.pdfLoader = false;
        });
    },
    handleKeyDown(event) {
      const key = event.key;
      if (key === 'ArrowDown') {
        this.$refs.scrollable.scrollTop += 50; // You can adjust the scrolling speed as needed
      } else if (key === 'ArrowLeft') {
        const currentIndex = this.tab ? ['one', 'two', 'three', 'four'].indexOf(this.tab) : 0;
        this.tab = currentIndex === 0 ? 'four' : ['one', 'two', 'three', 'four'][currentIndex - 1];
      } else if (key === 'ArrowRight') {
        const currentIndex = this.tab ? ['one', 'two', 'three', 'four'].indexOf(this.tab) : 0;
        this.tab = currentIndex === 3 ? 'one' : ['one', 'two', 'three', 'four'][currentIndex + 1];
      }
    },
  },
  mounted() {
    this.tab = 'one';
    this.assetName = this.$route.params.asset.replace(/-/g, ' ');
    this.fieldName = this.$route.params.field.replace(/-/g, ' ');
    this.wellName = this.$route.params.well;
    this.$refs.scrollable.focus();
  },
}
</script>